"use client";

import { c as _c } from "react/compiler-runtime";
import Image from "next/image";
import Link from "next/link";
import { CalendarIcon } from "lucide-react";
import { motion } from "motion/react";
import type { PostDetails } from "@/types/posts";
import { shimmer } from "@/lib/shimmer";
export function PostCard(t0) {
  const $ = _c(29);
  const {
    post
  } = t0;
  let t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      opacity: 0,
      y: 20
    };
    t2 = {
      opacity: 1,
      y: 0
    };
    t3 = {
      duration: 0.5
    };
    $[0] = t1;
    $[1] = t2;
    $[2] = t3;
  } else {
    t1 = $[0];
    t2 = $[1];
    t3 = $[2];
  }
  const t4 = post.link;
  const t5 = `${post.slug}`;
  const t6 = post.homeImageUrl ?? "/doge-troubleshoot.jpg";
  const t7 = post.title;
  let t8;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = shimmer([1024, 576]);
    $[3] = t8;
  } else {
    t8 = $[3];
  }
  let t9;
  if ($[4] !== post.title || $[5] !== t6) {
    t9 = <Image src={t6} alt={t7} width={1024} height={576} placeholder="blur" blurDataURL={t8} className="object-contain transition-all duration-500 group-hover:scale-[1.005]" />;
    $[4] = post.title;
    $[5] = t6;
    $[6] = t9;
  } else {
    t9 = $[6];
  }
  let t10;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <CalendarIcon className="text-muted-foreground/80 size-4" />;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  let t11;
  if ($[8] !== post.date) {
    t11 = <div className="flex items-center gap-0.5">{t10}<time dateTime={post.date} className="font-basis-grotesque-pro font-light text-muted-foreground/80 text-xs">{post.date}</time></div>;
    $[8] = post.date;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  let t13;
  let t14;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      opacity: 0,
      y: 10
    };
    t13 = {
      opacity: 1,
      y: 0
    };
    t14 = {
      delay: 0.2
    };
    $[10] = t12;
    $[11] = t13;
    $[12] = t14;
  } else {
    t12 = $[10];
    t13 = $[11];
    t14 = $[12];
  }
  let t15;
  if ($[13] !== post.title) {
    t15 = <motion.h2 className="font-basis-grotesque-pro font-medium text-base tracking-wider sm:text-2xl" initial={t12} animate={t13} transition={t14}>{post.title}</motion.h2>;
    $[13] = post.title;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  let t17;
  let t18;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      opacity: 0,
      y: 10
    };
    t17 = {
      opacity: 1,
      y: 0
    };
    t18 = {
      delay: 0.3
    };
    $[15] = t16;
    $[16] = t17;
    $[17] = t18;
  } else {
    t16 = $[15];
    t17 = $[16];
    t18 = $[17];
  }
  let t19;
  if ($[18] !== post.description) {
    t19 = <motion.p className="font-basis-grotesque-pro font-normal text-muted-foreground mt-2 line-clamp-2 text-sm tracking-wider" initial={t16} animate={t17} transition={t18}>{post.description}</motion.p>;
    $[18] = post.description;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] !== t11 || $[21] !== t15 || $[22] !== t19) {
    t20 = <div className="group-hover:bg-background/10 absolute -inset-x-5 inset-y-0 transition-all duration-500"><div className="bg-background/70 group-hover:bg-background/80 absolute inset-x-4 bottom-4 rounded-lg p-4 backdrop-blur-md transition-all duration-500"><div className="flex flex-col space-y-1">{t11}{t15}{t19}</div></div></div>;
    $[20] = t11;
    $[21] = t15;
    $[22] = t19;
    $[23] = t20;
  } else {
    t20 = $[23];
  }
  let t21;
  if ($[24] !== post.link || $[25] !== t20 || $[26] !== t5 || $[27] !== t9) {
    t21 = <motion.div initial={t1} animate={t2} transition={t3} className="group relative aspect-[16/9]! overflow-hidden mx-auto w-full"><Link href={t4} id={t5} className="relative block h-full overflow-hidden rounded-lg">{t9}{t20}</Link></motion.div>;
    $[24] = post.link;
    $[25] = t20;
    $[26] = t5;
    $[27] = t9;
    $[28] = t21;
  } else {
    t21 = $[28];
  }
  return t21;
}